import { render, staticRenderFns } from "./consignmentDetail.vue?vue&type=template&id=5524b402&scoped=true&"
import script from "./consignmentDetail.js?vue&type=script&lang=js&"
export * from "./consignmentDetail.js?vue&type=script&lang=js&"
import style0 from "./consignmentDetail.scss?vue&type=style&index=0&id=5524b402&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5524b402",
  null
  
)

export default component.exports